import directionWaypoints from "./directionWaypoints.component";

const directionWaypointsModule = angular
  .module("app.components.directionWaypoints", [])
  .component("directionWaypoints", directionWaypoints);

export default directionWaypointsModule;



// WEBPACK FOOTER //
// ./src/components/directionWaypoints/directionWaypoints.module.js